<template>
  <div class="statisticalAnalysis">
    <div class="topFrom" ref="sub">
      <el-form inline label-width="90px">
        <el-row :gutter="10">
          <el-col :span="12" style="{'display':'block' }">
            <el-form-item
              prop="accountType"
              :label="this.$t('maintenanceManage.search.partnersType')"
            >
              <el-select
                style="width: 100%"
                v-model="partnerType"
                label
                :placeholder="this.$t('maintenanceManage.search.partnersTypePlaceholder')"
                clearable
                filterable
              >
                <el-option
                  v-for="item in partnerTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="gird">
      <vxe-toolbar>
        <template v-slot:buttons>
          <vxe-button
            size="medium"
            type="primary"
            class="vxe-btn-primary"
            icon="el-icon-plus"
            @click="addRow()"
            >{{ $t('statisticalAnalysis.btnList.add') }}</vxe-button
          >
          <vxe-button
            size="medium"
            type="primary"
            class="vxe-btn-delete"
            icon="el-icon-delete"
            @click="removeSelected()"
            >{{ $t('statisticalAnalysis.btnList.del') }}</vxe-button
          >
          <vxe-button
            size="medium"
            type="primary"
            class="vxe-btn-save"
            icon="el-icon-document"
            @click="save()"
            >{{ $t('statisticalAnalysis.btnList.save') }}</vxe-button
          >
        </template>
      </vxe-toolbar>
      <vxe-table
        border
        show-overflow
        resizable
        ref="xGrid"
        class="vxe-table-element"
        size="mini"
        align="left"
        :auto-resize="true"
        :data="tableData"
        :row-style="rowStyle"
        :edit-rules="editRules"
        :toolbar="tableToolbar"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        @cell-click="rowClick"
        :checkbox-config="{ labelField: 'name', checkMethod }"
        :valid-config="{ autoPos: true, message: 'inline' }"
      >
        <vxe-table-column type="checkbox" width="60"></vxe-table-column>
        <vxe-table-column type="index" width="60" :title="$t('table.index')"></vxe-table-column>
        <!-- 事业部编码 -->
        <vxe-table-column
          field="controlAreaCode"
          width="150"
          :title="$t('statisticalAnalysis.table.businessDepartmentNo')"
        >
          <!-- :edit-render="{type: 'default'}" -->
          <!-- <template v-slot:edit="{ row }">
            <treeselect
              :options="businessDepartmentList"
              :defaultExpandLevel="Infinity"
              openDirection="auto"
              :clearable="false"
              :maxHeight="200"
              :zIndex="2999"
              :flat="true"
              :append-to-body="true"
              :currentValue="row.businessDepartmentNo"
              @select="(val)=>selectNode(val,scope)"
              :placeholder="$t('company.treeselect.searchIndex')"
              :searchPromptText="$t('company.treeselect.searchIndex')"
            />
          </template>-->
        </vxe-table-column>
        <!-- 事业部名称 -->
        <vxe-table-column
          field="controlAreaName"
          width="150"
          :title="$t('statisticalAnalysis.table.businessDepartmentDesc')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <treeselect
              :disabled="scope.row.bizFlag == 1"
              :options="businessDepartmentList"
              v-model="scope.row.controlAreaCode"
              :defaultExpandLevel="Infinity"
              openDirection="auto"
              :clearable="false"
              :maxHeight="200"
              :zIndex="2999"
              :flat="false"
              :multiple="false"
              :append-to-body="true"
              :normalizer="normalizer"
              :currentValue="scope.row.controlAreaName"
              @select="(val) => selectNode(val, scope)"
              :noResultsText="$t('company.treeselect.noData')"
              :placeholder="$t('company.treeselect.searchIndex')"
              :searchPromptText="$t('company.treeselect.searchIndex')"
            />
          </template>
          <template v-slot="{ row }">{{ row.controlAreaName }}</template>
        </vxe-table-column>
        <!-- 合作伙伴类型 -->
        <vxe-table-column
          field="partnerType"
          width="150"
          :title="$t('statisticalAnalysis.table.partnerType')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <!-- <ajax-select v-model="scope.row.unit" :apiUrl="dictApi" :apiData="creditLevelData"></ajax-select> -->
            <el-select
              class="inputWidth"
              filterable
              v-model="scope.row.partnerType"
              :disabled="scope.row.bizFlag == 1"
              clearable
              @change="changepartnerType(scope.row, scope)"
            >
              <el-option
                v-for="item in partnerTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-slot="{ row }">{{
            transferSelectLabel(row.partnerType, partnerTypeList)
          }}</template>
        </vxe-table-column>
        <!-- 合作伙伴编码 -->
        <vxe-table-column
          field="partnerNo"
          width="150"
          :title="$t('statisticalAnalysis.table.partnerNo')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <search-table
              :disabled="scope.row.bizFlag == 1"
              v-model="scope.row.partnerNo"
              searchType="customer"
              propName="partnerZhName"
              :isMultiple="true"
              :extraData="{ partnerType: scope.row.partnerType }"
              :currentValue="scope.row.partnerNo ? scope.row.partnerNo : ''"
              :checkRowKeys="scope.row.partnerNo ? [scope.row.partnerNo] : []"
              @input="(val) => chooseTable(val, scope.row, 'partnerNo', scope)"
            ></search-table>
          </template>
        </vxe-table-column>
        <!-- 合作伙伴名称 -->
        <vxe-table-column
          field="partnerName"
          width="150"
          :title="$t('statisticalAnalysis.table.partnerName')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <search-table
              :disabled="true"
              v-model="scope.row.partnerName"
              searchType="customer"
              propName="partnerZhName"
              :isMultiple="true"
              :extraData="{ partnerType: scope.row.partnerType, requestStatus: 'ZT03' }"
              :currentValue="scope.row.partnerName ? scope.row.partnerName : ''"
              :checkRowKeys="scope.row.partnerNo ? [scope.row.partnerNo] : []"
              @input="(val) => chooseTable(val, scope.row, 'partnerName', scope)"
            ></search-table>
          </template>
        </vxe-table-column>
        <!-- 信用级别 credit_level-->
        <vxe-table-column
          field="creditLevel"
          width="150"
          :title="$t('statisticalAnalysis.table.creditLevel')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <!-- <ajax-select v-model="scope.row.unit" :apiUrl="dictApi" :apiData="creditLevelData"></ajax-select> -->
            <el-select
              class="inputWidth"
              filterable
              v-model="scope.row.creditLevel"
              :disabled="scope.row.bizFlag == 1"
              clearable
            >
              <el-option
                v-for="item in levelOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-slot="{ row }">{{
            transferSelectLabel(row.creditLevel, levelOptions)
          }}</template>
        </vxe-table-column>
        <!-- 成立日期 -->
        <vxe-table-column
          field="registDate"
          width="180"
          :title="$t('statisticalAnalysis.table.registDate')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-date-picker
              class="inputWidth"
              :disabled="scope.row.bizFlag == 1"
              v-model="scope.row.registDate"
              type="date"
              clearable
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            ></el-date-picker>
          </template>
        </vxe-table-column>
        <!-- 注册资本 -->
        <vxe-table-column
          field="registAsset"
          width="150"
          :title="$t('statisticalAnalysis.table.registAsset')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <input-number
              :disabled="scope.row.bizFlag == 1"
              v-model="scope.row.registAsset"
              :max="99999999999.999999"
              :precision="6"
              @input="$refs.xGrid.updateStatus(scope)"
            ></input-number>
          </template>
          <template v-slot="scope">
            {{ Number(scope.row.registAsset).toFixed(2) }}
          </template>
        </vxe-table-column>
        <!-- 信用账户号 -->
        <vxe-table-column
          field="creditAccount"
          width="150"
          :title="$t('statisticalAnalysis.table.creditAccount')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-input
              :disabled="scope.row.bizFlag == 1"
              v-model="scope.row.creditAccount"
              @input="$refs.xGrid.updateStatus(scope)"
              clearable
              maxlength="32"
            ></el-input>
          </template>
        </vxe-table-column>
        <!-- 信用账户号描述 -->
        <vxe-table-column
          field="creditAccountDesc"
          width="150"
          :title="$t('statisticalAnalysis.table.creditAccountDesc')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-input
              :disabled="scope.row.bizFlag == 1"
              v-model="scope.row.creditAccountDesc"
              @input="$refs.xGrid.updateStatus(scope)"
              clearable
              maxlength="32"
            ></el-input>
          </template>
        </vxe-table-column>
        <!-- 有效期从 -->
        <vxe-table-column
          field="validStart"
          width="180"
          :title="$t('statisticalAnalysis.table.validStart')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-date-picker
              class="inputWidth"
              v-model="scope.row.validStart"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              clearable
              :picker-options="pickerStartOptions"
              @focus="() => handleFocusDate('start', scope.row)"
            ></el-date-picker>
          </template>
        </vxe-table-column>
        <!-- 有效期到 -->
        <vxe-table-column
          field="validEnd"
          width="180"
          :title="$t('statisticalAnalysis.table.validEnd')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-date-picker
              class="inputWidth"
              v-model="scope.row.validEnd"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              clearable
              :picker-options="pickerEndOptions"
              @focus="() => handleFocusDate('end', scope.row)"
            ></el-date-picker>
          </template>
        </vxe-table-column>
        <!-- 单边交易上限(低) -->
        <vxe-table-column
          field="minQuantity"
          width="155"
          :title="$t('statisticalAnalysis.table.minQuantity')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <input-number
              v-model="scope.row.minQuantity"
              :max="99999999999.999999"
              :precision="6"
              @input="$refs.xGrid.updateStatus(scope)"
            ></input-number>
            <!-- <el-input v-model="scope.row.minQuantity" @input="$refs.xGrid.updateStatus(scope)"  clearable maxlength="32"></el-input> -->
          </template>
          <template v-slot="scope">
            {{ Number(scope.row.minQuantity || 0).toFixed(2) }}
          </template>
        </vxe-table-column>
        <!-- 单边交易上限(高) -->
        <vxe-table-column
          field="maxQuantity"
          width="155"
          :title="$t('statisticalAnalysis.table.maxQuantity')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <input-number
              v-model="scope.row.maxQuantity"
              :max="99999999999.999999"
              :precision="6"
              @input="$refs.xGrid.updateStatus(scope)"
            ></input-number>
            <!-- <el-input v-model="scope.row.maxQuantity" @input="$refs.xGrid.updateStatus(scope)"  clearable maxlength="32"></el-input> -->
          </template>
          <template v-slot="scope">
            {{ Number(scope.row.maxQuantity || 0).toFixed(2) }}
          </template>
        </vxe-table-column>
        <!-- 单位 -->
        <vxe-table-column
          field="quantityUnit"
          width="150"
          :title="$t('statisticalAnalysis.table.quantityUnit')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-select
              class="inputWidth"
              v-if="scope.row.bizFlag !== 1"
              v-model="scope.row.quantityUnit"
              @change="$refs.xGrid.updateStatus(scope)"
              clearable
              filterable
            >
              <el-option
                v-for="item in unitOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-slot="{ row }">{{
            transferSelectLabel(row.quantityUnit, unitOptions)
          }}</template>
        </vxe-table-column>
        <vxe-table-column
          field="mark"
          width="150"
          :title="$t('statisticalAnalysis.table.mark')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <el-input
              v-if="scope.row.bizFlag !== 1"
              v-model="scope.row.mark"
              @input="$refs.xGrid.updateStatus(scope)"
              clearable
              maxlength="32"
            ></el-input>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  // import ajaxSelect from '@/components/form-item/ajax-select';
  // import SearchModal from '@/components/SearchModal';
  import API from '@/api/purchaseSalesCenter/tradingQuota/applicationQuota.js';
  import DataBaseAPI from '@/api/dataBase';
  import searchTable from '@/components/form-item/search-table';
  import InputNumber from '@/components/form-item/input-number';
  import XEUtils from 'xe-utils';
  export default {
    name: 'statisticalAnalysis',
    components: {
      // SearchModal,
      searchTable,
      // ajaxSelect,
      InputNumber,
    },
    data() {
      return {
        load: false,
        tableData: [],
        partnerType: '',
        divisionNameList: [], //事业部名称
        creditRatingList: [], //信用级别
        businessDepartmentList: [], //事业部门列表
        tableToolbar: {
          id: 'toolbar',
        },
        dictApi: API.DATA_DICT, // TODO 测试api
        pickerStartOptions: {},
        pickerEndOptions: {},
        unitOptions: [
          { label: '吨', value: 'T' },
          { label: '千克', value: 'KG' },
        ],
        normalizer(node) {
          //只能选择根节点
          if (node.children) {
            node.children.map((item) => {
              item['isDisabled'] = true;
            });
          }
          return node;
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        //信用等级list
        levelOptions(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'credit_level').dictList;
          }
        },
        //单位下拉
        // unitOptions(state){
        //   if(state.dict.dictList.length>10){
        //     return  state.dict.dictList.find(it=>it.dictType=="basic_unit").dictList;
        //   }
        // },
        partnerTypeList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'partner_type').dictList;
          }
        },
      }),
      editRules() {
        return {
          controlAreaName: [
            {
              required: true,
              message: this.$t('statisticalAnalysis.table.businessDepartmentDescPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          partnerType: [
            {
              required: true,
              message: this.$t('statisticalAnalysis.table.partnerTypeNamePlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          partnerNo: [
            {
              required: true,
              message: this.$t('statisticalAnalysis.table.partnerNoPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          partnerName: [
            {
              required: true,
              message: this.$t('statisticalAnalysis.table.partnerNamePlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          accountType: [
            {
              required: true,
              message: this.$t('statisticalAnalysis.table.partnerTypeNamePlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          creditLevel: [
            {
              required: true,
              message: this.$t('statisticalAnalysis.table.creditLevelPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          creditAccount: [
            {
              required: true,
              message: this.$t('statisticalAnalysis.table.creditAccountPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          creditAccountDesc: [
            {
              required: true,
              message: this.$t('statisticalAnalysis.table.creditAccountDescPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          registAsset: [
            {
              required: true,
              message: this.$t('statisticalAnalysis.table.registAssetPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          validStart: [
            {
              required: true,
              message: this.$t('statisticalAnalysis.table.validStartPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          validEnd: [
            {
              required: true,
              message: this.$t('statisticalAnalysis.table.validEndPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          registDate: [
            {
              required: true,
              message: this.$t('statisticalAnalysis.table.registDatePlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          minQuantity: [
            {
              required: true,
              message: this.$t('statisticalAnalysis.table.minQuantityPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          maxQuantity: [
            {
              required: true,
              message: this.$t('statisticalAnalysis.table.maxQuantityPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          quantityUnit: [
            {
              required: true,
              message: this.$t('statisticalAnalysis.table.quantityUnitPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
        };
      },
      partner() {
        return {
          API: API.APPLICATION_CREDIT_LIST_API,
          query: {
            userCompany: null,
          },
        };
      },
    },
    /**页面必要代码Start */
    mounted() {
      this.getData();
      this.initDepartment(); //事业部门
      this.getButtonList();
    },
    methods: {
      //转换
      transferSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
        });
      },
      //点击表格记录正在编辑哪一行
      rowClick(row) {
        this.rowIndex = row.$rowIndex;
      },
      //表格下拉表格赋值
      chooseTable(val, row, field, scope) {
        if (field === 'partnerNo') {
          row.mdPartnerType = val ? val[0].partnerType : '';
        }
        if (field === 'partnerNo' || field === 'partnerName') {
          //仓库
          const partner = row[field] ? row[field][0] : null;
          //如果没有选产品 则不走下面的逻辑
          if (partner) {
            row.partnerNo = partner.partnerCode || null;
            row.partnerName = partner.partnerZhName;
            row.registDate = partner.establishedDate || '';
            row.registAsset = partner.registeredAssets || '';
          }
        }
        this.$refs.xGrid.updateStatus(scope);
      },
      // 获取数据
      getData() {
        if (this.$route.query && this.$route.query.ids) {
          const params = {
            ids: JSON.parse(this.$route.query.ids),
          };
          this.load = true;
          this.$axios.post(API.DETAIL_DATA_API, params).then((res) => {
            this.load = false;
            if (0 == res.data.code) {
              this.tableData = res.data.data;
            } else {
              this.$alert(res.data.msg);
            }
          });
        }
      },
      //修改表格合作伙伴类型
      changepartnerType(row, scope) {
        console.log(row, scope);
        //  row.partnerName=null;
        //  row.partnerNo=null;
        //  row.registDate='';
        //  row.registAsset='';
        //  this.$refs.xGrid.updateStatus(scope);
      },
      // 开始结束日期
      handleFocusDate(type, row) {
        this.$refs.xGrid.reloadRow(row);
        const pickerOptions = {
          disabledDate: (time) => {
            return this.disabledDate(time, row, type);
          },
        };
        if (type == 'start') {
          this.pickerStartOptions = pickerOptions;
        } else {
          this.pickerEndOptions = pickerOptions;
        }
      },
      // 开始结束日期禁用日期
      disabledDate(time, row, type) {
        if (type === 'end') {
          let startDate = row.validStart;
          if (startDate) {
            return time.getTime() < new Date(startDate).getTime() - 24 * 60 * 60 * 1000;
          }
        } else {
          let endDate = row.validEnd;
          if (endDate) {
            return time.getTime() > new Date(endDate).getTime();
          }
        }
      },
      checkMethod({ row }) {
        if (row.id) {
          return false;
        }
        return true;
      },
      //行项目样式
      rowStyle({ row }) {
        let newDate = Math.floor(new Date().getTime() / (1000 * 60 * 60 * 24));
        let validEnd = Math.floor(new Date(row.validEnd).getTime() / (1000 * 60 * 60 * 24));
        if (validEnd < newDate) {
          return {
            backgroundColor: '#f0f0f0',
          };
        }
      },
      //事业部门
      initDepartment() {
        const params = {
          tenantCode: this.userInfo.tenantCode,
          adminFlag: this.userInfo.adminFlag,
          currentStatus: '0',
          // treeFlag: 1
        };
        this.$axios.post(DataBaseAPI.LIST_TREE, params).then((res) => {
          if (0 == res.data.code && res.data.data && res.data.data.length > 0) {
            this.businessDepartmentList = res.data.data;
            this.getSelectedNode(this.businessDepartmentList, this.businessDepartmentList);
          }
        });
      },
      //删掉没有子节点的children
      getSelectedNode(nodeData) {
        nodeData.forEach((item) => {
          if ('children' in item && item.children.length === 0) {
            delete item.children;
          } else if ('children' in item && item.children.length) {
            this.getSelectedNode(item.children, item);
          }
        });
      },
      //选择事业部门
      selectNode(node, scope) {
        this.tableData[this.rowIndex].controlAreaCode = node.id;
        this.tableData[this.rowIndex].controlAreaName = node.label;
        this.$refs.xGrid.updateStatus(scope);
      },
      //增加一行
      addRow() {
        if (this.partnerType) {
          let row = {
            partnerType: this.partnerType,
            registDate: '',
            registAsset: '',
            controlAreaCode: null,
            controlAreaName: null,
            validStart: '',
            validEnd: '',
            mdPartnerType: '',
          };
          this.tableData.unshift(row);
          this.$refs.xGrid.updateStatus();
        } else {
          this.$message({
            showClose: true,
            message: this.$t('statisticalAnalysis.tips.partnerTypePlaceholder'),
            type: 'error',
          });
        }
      },
      //删除选中行
      removeSelected() {
        let data = this.$refs.xGrid.getSelectRecords();
        if (data && data.length > 0) {
          this.$confirmAction()
            .then(() => {
              this.$refs.xGrid.removeSelecteds();
              this.tableData = this.$refs.xGrid.getTableData().fullData;
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('statisticalAnalysis.tips.noSelect'),
            type: 'error',
          });
        }
      },
      //重叠验证
      valid(data) {
        let flag = true;
        if (data.length === 0) {
          this.$message({
            type: 'error',
            message: this.$t('statisticalAnalysis.tips.noData'),
          });
          flag = false;
        }
        data.map((item) => {
          //判断开始时间是否小于结束时间
          if (Number(item.minQuantity) > Number(item.maxQuantity)) {
            this.$message({
              type: 'error',
              message: this.$t('credit.msg.validQuantity'),
            });
            flag = false;
          }
        });
        return flag;
      },
      //保存
      save() {
        this.$refs.xGrid.validate((valid) => {
          if (valid) {
            const { tenantCode, companyCode, companyName, departmentCode, departmentName } =
              this.userInfo;
            const obj = { tenantCode, companyCode, companyName, departmentCode, departmentName };
            const params = {
              list: this.tableData.map((item) => {
                return (item = Object.assign(item, obj));
              }),
              // ids:this.tableData.map(item => {
              //   return item.id
              // })
            };
            let flag = this.valid(this.tableData);
            if (flag) {
              this.load = true;
              this.$axios
                .post(API.SAVE_DATA_API, { ...params, businessGroup: this.userInfo.businessGroup })
                .then((res) => {
                  this.load = false;
                  if (res.data.code === 0) {
                    this.$message({
                      showClose: true,
                      message: res.data.msg,
                      type: 'success',
                    });
                    let path = {
                      fromPath: {
                        path: this.$route.query.ids
                          ? '/applicationQuota/editTransaction'
                          : '/applicationQuota/addTransaction',
                        name: this.$route.query.ids ? 'editTransaction' : 'addTransaction',
                        meta: {
                          keepAlive: true,
                          title: this.$route.query.ids
                            ? this.$t('maintenanceManage.router.editTransaction')
                            : this.$t('maintenanceManage.router.addTransaction'),
                        },
                      },
                      toPath: {
                        path: '/applicationQuota/maintenanceManage',
                        name: 'maintenanceManage',
                        meta: {
                          keepAlive: false,
                          title: this.$t('maintenanceManage.router.maintenanceManage'),
                        },
                      },
                    };
                    this.$store.dispatch('tagsView/backTabView', path).then(() => {
                      this.$nextTick(() => {
                        this.$router.push(path.toPath);
                      });
                    });
                  } else {
                    this.$message({
                      showClose: true,
                      message: res.data.msg,
                      type: 'error',
                    });
                  }
                });
            }
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .statisticalAnalysis {
    .topFrom {
      padding: 26px 0 8px 10px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 3px 17px 0px rgba(72, 89, 102, 0.16);
      border-radius: 3px;
    }
    .gird {
      margin-top: 10px;
      padding: 10px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 3px 17px 0px rgba(72, 89, 102, 0.16);
      border-radius: 3px;
    }
  }
</style>
